import React from 'react';
type ChakraOrnamentProps = {
  className?: string;
  variant?: 'column' | 'flower';
};
const chakraColors = ['#9B5A4B', '#C27A4E', '#B79A48', '#718266', '#648993', '#6E6C9A', '#87658B'];
export function ChakraOrnament({
  className = '',
  variant = 'column'
}: ChakraOrnamentProps) {
  if (variant === 'flower') {
    return <svg viewBox="0 0 120 120" className={className} fill="none" aria-hidden="true" data-id="element-18" data-mp="2exnrczx5zzes">
        <circle cx="60" cy="60" r="50" stroke="#76557C" strokeOpacity="0.35" data-id="element-19" data-mp="1r8l2p84456as" />
        <circle cx="60" cy="60" r="35" stroke="#BB9355" strokeOpacity="0.5" data-id="element-20" data-mp="1m9044ysuuzyl" />
        {Array.from({
        length: 8
      }, (_, index) => {
        const angle = index * Math.PI / 4;
        const x = 60 + Math.cos(angle) * 34;
        const y = 60 + Math.sin(angle) * 34;
        return <circle key={index} cx={x} cy={y} r="12" stroke="#76557C" strokeOpacity="0.35" data-id="element-21" data-mp="3bnekaupt5eih" />;
      })}
        <path d="M60 10v100M10 60h100M25 25l70 70M95 25 25 95" stroke="#BB9355" strokeOpacity="0.45" data-id="element-22" data-mp="36obntynw8gm4" />
        <circle cx="60" cy="60" r="10" fill="#76557C" fillOpacity="0.14" stroke="#76557C" strokeOpacity="0.45" data-id="element-23" data-mp="mblywz4cjt5z" />
      </svg>;
  }
  return <svg viewBox="0 0 48 176" className={className} fill="none" aria-hidden="true" data-id="element-24" data-mp="qbmb0d3z3s9v">
      <path d="M24 8v160" stroke="#76557C" strokeOpacity="0.25" data-id="element-25" data-mp="vd1yebtmiavf" />
      {chakraColors.map((color, index) => {
      const y = 20 + index * 23;
      return <g key={color} data-id="element-26" data-mp="2ncthndslqoj" data-mpi={index}>
            <circle cx="24" cy={y} r="9" fill={color} fillOpacity="0.18" stroke={color} strokeOpacity="0.68" data-id="element-27" data-mp="2o4igfcvwq5u" />
            <circle cx="24" cy={y} r="3" fill={color} fillOpacity="0.85" data-id="element-28" data-mp="7nhb5gqfsrgc" />
          </g>;
    })}
    </svg>;
}